import styled from 'styled-components';

export const MarketplaceContainer = styled.section`
  background: linear-gradient(180deg, #101010 0%, #000000 100%);
  color: #ffffff;
  padding: 80px 20px;
  text-align: center;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 50px 15px;
  }
  
  @media (max-width: 480px) {
    padding: 40px 10px;
  }
`;

export const MarketplaceTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: bold;
  margin-bottom: 15px;
  line-height: 1.2;
  white-space: normal;
  word-break: keep-all;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }
  
  @media (max-width: 480px) {
    font-size: 2.0rem;
  }
`;

export const MarketplaceSubtitle = styled.p`
  font-size: 1.1rem;
  margin-bottom: 50px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.9;
  line-height: 1.6;
  white-space: normal;
  word-break: keep-all;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 30px;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    margin-bottom: 25px;
  }
`;

export const ButtonsOuterContainer = styled.div`
  max-width: 780px;
  background-color: #E9ECEF;
  border-radius: 35px;
  padding: 10px;
  margin: 0 auto 70px auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  @media (max-width: 820px) {
    max-width: 90%;
  }

  @media (max-width: 768px) {
    max-width: 95%;
    height: auto;
    margin-bottom: 40px;
    padding: 8px;
    border-radius: 25px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 30px;
    padding: 6px;
    border-radius: 20px;
  }
`;

export const MarketplaceButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    gap: 6px;
  }
`;

export const MarketplaceButton = styled.button`
  background-color: ${props => props.isActive ? '#FF6600' : 'transparent'};
  color: ${props => props.isActive ? '#FFFFFF' : '#505050'};
  border: none;
  padding: 14px 20px;
  border-radius: 25px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  text-align: center;
  white-space: nowrap;
  min-width: 0;

  &:hover {
    background-color: ${props => props.isActive ? '#E55A00' : '#DDDDDD'};
    color: ${props => props.isActive ? '#FFFFFF' : '#333333'};
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 0.8rem;
    padding: 12px 15px;
    flex: none;
    white-space: normal;
    border-radius: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.75rem;
    padding: 10px 12px;
    border-radius: 15px;
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  svg {
    width: 18px;
    height: 18px;
    fill: ${props => props.isActive ? '#FFFFFF' : '#707070'};
    transition: fill 0.3s ease;
  }

  ${MarketplaceButton}:hover & svg {
    fill: ${props => props.isActive ? '#FFFFFF' : '#333333'};
  }

  @media (max-width: 768px) {
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const MarketplaceFeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 700px;
    gap: 35px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    max-width: 350px;
    gap: 30px;
  }
`;

export const MarketplaceFeatureCard = styled.div`
  background: linear-gradient(135deg, rgba(255, 102, 0, 0.05) 0%, rgba(255, 102, 0, 0.02) 100%);
  border: 1px solid rgba(255, 102, 0, 0.1);
  padding: 30px 25px;
  border-radius: 16px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 200px;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    transform: translateY(-5px);
    background: linear-gradient(135deg, rgba(255, 102, 0, 0.08) 0%, rgba(255, 102, 0, 0.04) 100%);
    border-color: rgba(255, 102, 0, 0.2);
    box-shadow: 0 10px 30px rgba(255, 102, 0, 0.1);
  }

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    min-height: auto;
    padding: 25px 20px;
  }
`;

export const FeatureIcon = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #FF6600 0%, #FF8533 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 8px 25px rgba(255, 102, 0, 0.3);
  transition: all 0.3s ease;

  svg {
    width: 28px;
    height: 28px;
    color: #FFFFFF;
    stroke-width: 2;
  }

  ${MarketplaceFeatureCard}:hover & {
    transform: scale(1.1);
    box-shadow: 0 12px 35px rgba(255, 102, 0, 0.4);
  }

  @media (max-width: 768px) {
    width: 55px;
    height: 55px;
    
    svg {
      width: 26px;
      height: 26px;
    }
  }
`;

export const FeatureText = styled.p`
  font-size: 1rem;
  color: #E0E0E0;
  line-height: 1.6;
  margin-bottom: 20px;
  flex-grow: 1;
  font-weight: 400;
  white-space: normal;
  word-break: keep-all;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

export const CardBottomLine = styled.div`
  width: 40px;
  height: 4px;
  background: linear-gradient(90deg, #FF6600 0%, #FF8533 100%);
  border-radius: 2px;
  align-self: flex-start;
  transition: all 0.3s ease;

  ${MarketplaceFeatureCard}:hover & {
    width: 60px;
  }

  @media (max-width: 768px) {
    align-self: center;
    margin-top: 15px;
  }
`;